import { SDK_StackCfKey } from "@quickpoint.me/shared";

function formatDate(ms: number) {
  const date = new Date(ms);
  return date.toLocaleDateString("us-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  });
}

export type FileTreeType = Record<string, string | boolean | number | Record<string, string | boolean | number>>;

function groupByFolder(stackCfKeys: SDK_StackCfKey[]): FileTreeType {
  // Create a new object to represent the file tree.
  const fileTree: FileTreeType = {};

  // Iterate over the array of file names.
  for (const stackCfKey of stackCfKeys) {
    if (stackCfKey) {
      // Split the file name into an array of path segments.
      const pathSegments = stackCfKey?.key.split("/");

      // Starting at the root of the file tree object, traverse the path segments,
      // creating new objects for each directory along the way.
      let currentDirectory = fileTree;
      for (const pathSegment of pathSegments) {
        if (!currentDirectory[pathSegment]) {
          currentDirectory[pathSegment] = {};
          currentDirectory["isFolder"] = true;
        }
        // @ts-expect-error: figure this out
        currentDirectory = currentDirectory[pathSegment];
      }

      // Once you reach the last path segment, create a new file object in the current directory.
      currentDirectory["isFile"] = true;
      currentDirectory["stackCfKey"] = stackCfKey.key;
      currentDirectory["updated"] = stackCfKey.updated;
      currentDirectory["created"] = stackCfKey.created;
      currentDirectory["updatedString"] = formatDate(stackCfKey.updated);
      currentDirectory["createdString"] = formatDate(stackCfKey.created);
    }
  }

  return fileTree;
}

export default groupByFolder;
